import { BC_REPORTS, PARTNERS } from "app_constants";
import { ICON_TYPE } from "components/icons/icon";
import {
  DateRangeSupport,
  QueryParamDateFormat,
  formatForQueryParams,
} from "helpers/shared/formatters/dates";

import type { ISectionProps } from "types/navigation";

const FINANCE: ISectionProps = {
  feature: "Finance",
  icon: ICON_TYPE.FINANCE,
  path: "/finance",
  level: ["store", "brand"],
  dateSupport: DateRangeSupport.NONE,
  subSections: [
    {
      feature: "Batches",
      app: PARTNERS,
      level: ["store"],
      scope: ["staff", "superuser"],
      path: "/finance/batches",
      legacyPath: ({ startDate, endDate }) => {
        return (
          "/finance/batches_and_deposits/" +
          formatForQueryParams(startDate, QueryParamDateFormat.UPSERVE) +
          "..." +
          formatForQueryParams(endDate, QueryParamDateFormat.UPSERVE) +
          "/batches"
        );
      },
      dateSupport: DateRangeSupport.FULL,
    },
    {
      feature: "Deposits",
      app: PARTNERS,
      level: ["store"],
      scope: ["staff", "superuser"],
      path: "/finance/deposits",
      legacyPath: ({ startDate, endDate }) => {
        return (
          "/finance/batches_and_deposits/" +
          formatForQueryParams(startDate, QueryParamDateFormat.UPSERVE) +
          "..." +
          formatForQueryParams(endDate, QueryParamDateFormat.UPSERVE) +
          "/deposits"
        );
      },
      dateSupport: DateRangeSupport.FULL,
    },
    {
      feature: "Payments",
      app: BC_REPORTS,
      level: ["store"],
      scope: ["staff", "superuser"],
      path: "/finance/payment_authorization",
      legacyPath: ({ startDate, endDate }) => {
        return (
          "/reports/payment_authorization" +
          "?startDate=" +
          formatForQueryParams(startDate, QueryParamDateFormat.BREADCRUMB) +
          "&endDate=" +
          formatForQueryParams(endDate, QueryParamDateFormat.BREADCRUMB)
        );
      },
      dateSupport: DateRangeSupport.FULL,
    },
    {
      feature: "Card Fees",
      app: PARTNERS,
      level: ["store"],
      scope: ["staff", "superuser"],
      path: "/finance/card_fees",
      // card_fees url only takes month as a range, e.g. 2018-01
      // for now just use the month of the start date
      legacyPath: ({ startDate }) => {
        return (
          "/finance/fees/" +
          formatForQueryParams(
            startDate,
            QueryParamDateFormat.UPSERVE_MONTH_ONLY
          )
        );
      },
      dateSupport: DateRangeSupport.FULL,
    },
    // TODO: Once the backend work is done, show this menu item if the store has a Recurly link
    // {
    //   feature: "Subscription Billing",
    //   app: PARTNERS,
    //   level: ["store"],
    //   scope: ["staff", "superuser"],
    //   path: "/finance/subscription_billing",
    //   legacyPath: () => "/dangerous/link", // TODO: Recurly URL
    //   dateSupport: DateRangeSupport.NONE,
    // },
    {
      feature: "Transaction Search",
      app: PARTNERS,
      level: ["store"],
      scope: ["staff", "superuser"],
      path: "/finance/transaction_search",
      legacyPath: () => "/finance/transaction_search",
      dateSupport: DateRangeSupport.NONE,
    },
    {
      feature: "Accounting Export",
      app: BC_REPORTS,
      level: ["store"],
      scope: ["staff", "superuser"],
      path: "/finance/accounting_export",
      legacyPath: ({ startDate, endDate }) => {
        return (
          "/reports/quickbooks_settings" +
          "?startDate=" +
          formatForQueryParams(startDate, QueryParamDateFormat.BREADCRUMB) +
          "&endDate=" +
          formatForQueryParams(endDate, QueryParamDateFormat.BREADCRUMB)
        );
      },
      dateSupport: DateRangeSupport.FULL,
    },
  ],
};

export default FINANCE;
